export default __webpack_public_path__ + "static/media/CSS_certificate.daebb38a.jpg";